import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import OnboardUP from "@components/utils/Auth/components/AuthUsernamePassword/OnboardUP/OnboardUP";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { OnboardMode } from "@constants";
import { usePostLoginHandler } from "@hooks/usePostLoginHandler";
import { useCallback } from "react";

interface OnboardStepProps extends OnboardingStepProps {
  defaultMode: OnboardMode;
}

const OnboardStep = ({ defaultMode, handleClose, navigate, layout }: OnboardStepProps) => {
  const { loginFlowHandlers, registerFlowHandlers } = usePostLoginHandler({
    flowMode: "dialog",
    registerFlowConfigs: {
      navigateStep: navigate,
    },
  });

  const handleForgotSecret = useCallback(() => {
    navigate(OnboardingDialogStep.ForgotSecret);
  }, [navigate]);

  return (
    <OnboardingDialogLayout
      layout={layout}
      navigation={{
        close: {
          onClick: handleClose,
        },
      }}
      features={{
        showCloseButton: true,
        showLanguageSelect: true,
        showChatButton: true,
      }}
      variant="welcome"
    >
      <OnboardUP
        defaultMode={defaultMode}
        onForgotSecret={handleForgotSecret}
        onLoginSuccess={loginFlowHandlers.handleLoginSuccess}
        onRegisterAndLoginSuccess={registerFlowHandlers.handleLoginSuccess}
        onPostLoginCheckFailed={registerFlowHandlers.handlePostLoginCheckFailed}
        onPostLoginCheckPassed={registerFlowHandlers.handlePostLoginCheckPassed}
      />
    </OnboardingDialogLayout>
  );
};

export default OnboardStep;
